export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./lk-competencies-item-legal.vue?vue&type=template&id=5238cd60&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/lk/lk-competencies-item/lk-competencies-item-legal.vue?vue&type=template&id=5238cd60&
// module id = 1139
// module chunks = 0